import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Pagination,
  Chip,
  InputAdornment,
} from "@mui/material";
import { Search, Delete, Edit } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import Addicon from "../../assets/svg/Addicon.svg";
import Enterprises from "./enterprises";
import { Getentrprise, deleteEnterprise } from "../../store/enterprise/action";
import DeleteConfirmationPopup from "../common/DeleteConfirmationPopup";

const getStatusStyle = (status) => ({
  color: status ? "#027A48" : "#B42318",
  backgroundColor: status ? "#ECFDF3" : "#FEF3F2",
  padding: "5px 10px",
  borderRadius: "15px",
  display: "inline-block",
});

const EnterprisesList = () => {
  const dispatch = useDispatch();
  const { enterpriseslist } = useSelector((state) => state.enterprises);

  const [open, setOpen] = useState(false);
  const [editdata, setEditdata] = useState(null);
  const [Alert, setAlert] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;

  useEffect(() => {
    dispatch(Getentrprise({}));
  }, [dispatch]);

  const handleDeleteConfirm = () => {
    dispatch(deleteEnterprise({ EnterpriseID: editdata?.EnterpriseID }));
    setAlert(false);
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleClose = () => {
    setOpen(false);
    setEditdata(null);
  };

  // ✅ Filtered + paginated data
  const filteredRows =
    enterpriseslist?.filter((row) =>
      row?.EnterpriseName?.toLowerCase().includes(searchText.toLowerCase())
    ) || [];

  const totalRows = filteredRows.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);

  const paginatedRows = filteredRows.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  return (
    <>
      <Box
        sx={{
          margin: "25px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={500}>
            Enterprises
          </Typography>
          <Typography variant="body2" color="textSecondary">
            List of all the Enterprises
          </Typography>
        </Box>
        <Box display="flex" gap={2} alignItems="center">
          <Button
            sx={{ height: "40px" }}
            variant="contained"
            endIcon={<img src={Addicon} alt="Add" />}
            onClick={() => setOpen(true)}
          >
            Add
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          padding: "20px",
          backgroundColor: "#fff",
          margin: "25px",
          borderRadius: "8px",
        }}
      >
        <TextField
          size="small"
          placeholder="Search Enterprise Name"
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            setCurrentPage(1);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Enterprise Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Enterprise Type</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.map((row) => (
                <TableRow key={row.EnterpriseID}>
                  <TableCell>{row?.EnterpriseName}</TableCell>
                  <TableCell>
                    <Box sx={getStatusStyle(row?.IsActive)}>
                      {row?.IsActive ? "Active" : "Inactive"}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip label={row?.EnterpriseType} size="small" />
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => {
                        setOpen(true);
                        setEditdata(row);
                      }}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setAlert(true);
                        setEditdata(row);
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {paginatedRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No matching enterprises found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            mt: 2,
          }}
        >
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            color="primary"
            siblingCount={0}
            boundaryCount={1}
          />
        </Box>

        {/* Delete confirmation popup */}
        <DeleteConfirmationPopup
          open={Alert}
          onClose={() => setAlert(false)}
          onConfirm={handleDeleteConfirm}
          title="Are you sure you want to delete this? This action cannot be undone."
        />

        {/* Add/Edit Enterprise Modal */}
        <Enterprises open={open} OnClose={handleClose} editdata={editdata} />
      </Box>
    </>
  );
};

export default EnterprisesList;
